import axios from "axios";
import { clearSession, getToken } from "utils/authStorage";

export const API_URL = (
  process.env.REACT_APP_API_URL || "http://localhost:7070"
).replace(/\/$/, "");

export const IMG_URL = (
  process.env.REACT_APP_IMG_URL || API_URL
).replace(/\/$/, "");

const client = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const path = window.location.pathname;
    if (status === 401 && !path.startsWith("/auth")) {
      clearSession();
      window.location.assign("/auth/sign-in");
    }
    return Promise.reject(error);
  }
);

export default client;
